<section id="terms-and-conditions">
    <div class="content-wrapper">
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <div class="container">
                        <div class="card">
                            <div class="kb-search-content col-sm-12 col-md-12">
                                <div class="card text-center cursor-pointer">
                                    <h2 class="card-title mt-1">Terms and Conditions</h2>
                                    <div class="card-body">
                                        <div class="row">
                                        </div>
                                        <h4 class="card-title shadow-bottom-light font-weight-light">
                                            We know it’s tempting to skip these Terms of Service,
                                            but it’s important to establish what you can expect from us as you use IEC
                                            University services,
                                            and what we expect from you.</h4>
                                        <p class="card-text mt-1">
                                            By law, you have certain rights that can’t be limited by a contract like
                                            these terms of service.
                                            These terms are in no way intended to restrict those rights.

                                            These terms describe the relationship between you and IEC University.
                                            They don’t create any legal rights for other people or organizations, even
                                            if others benefit from that relationship under these terms.

                                            We want to make these terms easy to understand, so we’ve used examples from
                                            our services.
                                            But not all services mentioned may be available in your country.

                                            If these terms conflict with the service-specific additional terms, the
                                            additional terms will govern for that service.

                                            If it turns out that a particular term is not valid or enforceable, this
                                            will not affect any other terms.

                                            If you don’t follow these terms or the service-specific additional terms,
                                            and
                                            we don’t take action right away, that doesn’t mean we’re giving up any
                                            rights that we may have, such as taking action in the future.

                                            We may update these terms and service-specific additional terms (1) to
                                            reflect changes in our services or
                                            how we do business — for example, when we add new services, features,
                                            technologies,
                                            pricing, or benefits (or remove old ones), (2) for legal, regulatory, or
                                            security reasons, or (3) to prevent abuse or harm.

                                            If we materially change these terms or service-specific additional terms,
                                            we’ll provide you with reasonable advance notice and the opportunity to
                                            review the changes,
                                            except (1) when we launch a new service or feature, or (2) in urgent
                                            situations,
                                            such as preventing ongoing abuse or responding to legal requirements.
                                            If you don’t agree to the new terms, you should remove your content and stop
                                            using the services.
                                            You can also end your relationship with us at any time by closing your IEC
                                            University Account. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
